import { render } from "./Footer.vue?vue&type=template&id=4a7077c3&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=4a7077c3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a7077c3"

export default script